import { render, staticRenderFns } from "./tracklist-block.vue?vue&type=template&id=50cddeb8&"
import script from "./tracklist-block.vue?vue&type=script&lang=js&"
export * from "./tracklist-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports